@if (loading()) {
<div class="row g-3 m-2 mb-3 placeholder-glow">
  @for (i of [0, 1, 2]; track i) {
  <div class="col-12 col-md-4">
    <span class="placeholder rounded placeholder-doc"></span>
  </div>
  }
</div>
} @else {
<div class="row g-3 m-2 mb-3">
  @if (files().length > 0) { @for (doc of files(); track doc.id) {
  <div class="col-12 col-md-4">
    <app-attachment [file]="doc" />
  </div>
  } } @else {
  <p class="mb-0 description-text">
    {{ "admin.common.noDocuments" | translate }}
  </p>
  }
</div>
}
